"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.updateFinCostCenterSchema = exports.createFinCostCenterSchema = exports.finCostCenterShape = void 0;
const zod_1 = require("zod");
/** Enterprise Architecture Handbook v1.0 (OP Billing Administration, Module 3 — Cost Center Mapping). */
exports.finCostCenterShape = {
    code: zod_1.z.string().min(1).max(20),
    name: zod_1.z.string().min(1).max(255),
    parentCostCenterId: zod_1.z.string().uuid().optional(),
    departmentId: zod_1.z.string().uuid().optional(),
};
exports.createFinCostCenterSchema = zod_1.z.object(exports.finCostCenterShape);
exports.updateFinCostCenterSchema = zod_1.z.object(exports.finCostCenterShape).partial();
//# sourceMappingURL=fin-cost-center.schema.js.map